import * as React from 'react';
// import DownOutlined from '@ant-design/icons/DownOutlined';
// import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import CheckOutlined from '@ant-design/icons/CheckOutlined';
// import CloseOutlined from '@ant-design/icons/CloseOutlined';
// import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
// import SearchOutlined from '@ant-design/icons/SearchOutlined';
import ControlOpen from '../../_util/bonreeIcons/ControlOpen';
import ControlCloseCircle from '../../_util/bonreeIcons/ControlCloseCircle';
import ControlCloseSmall from '../../_util/bonreeIcons/ControlCloseSmall';
import Search from '../../_util/bonreeIcons/Search';
export default function getIcons({ suffixIcon, clearIcon, menuItemSelectedIcon, removeIcon, 
// loading,
multiple, prefixCls, }) {
    // Clear Icon
    let mergedClearIcon = clearIcon;
    if (!clearIcon) {
        mergedClearIcon = <ControlCloseCircle />;
    }
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) {
        mergedSuffixIcon = suffixIcon;
    }
    // else if (loading) {
    //   mergedSuffixIcon = <LoadingOutlined spin />;
    // }
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = ({ open, showSearch }) => {
            if ((multiple && open) || (!multiple && showSearch && open)) {
                return <Search className={iconCls}/>;
            }
            return <ControlOpen className={iconCls}/>;
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) {
        mergedItemIcon = menuItemSelectedIcon;
    }
    else if (multiple) {
        mergedItemIcon = <CheckOutlined />;
    }
    else {
        mergedItemIcon = null;
    }
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) {
        mergedRemoveIcon = removeIcon;
    }
    else {
        mergedRemoveIcon = <ControlCloseSmall />;
    }
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon,
    };
}
